import "./buildFleet.css";
import { useNavigate } from "react-router-dom";
import ArielView1500E from "../../../assets/png/ArielView1500E.png";
import { RouterPaths } from "../../../router/router";

const BuildFleet = () => {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:items-stretch">
        {/* Left — vehicle image + Explore button */}
        <div className="flex flex-col">
          <div className="flex-1 overflow-hidden lg:min-h-0 min-h-[280px] sm:min-h-[360px] lg:border-r-[8px] border-[#b4875e]">
            <img
              src={ArielView1500E}
              alt="Tuatara Vehicle"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="px-[20px] lg:px-[40px] py-[18px] lg:py-[24px] bg-white">
            {/* <button
              className="bg-[#F2F2F2] border-[#5B792E] border-[3px] lg:border-[4px] rounded font-[Roboto] xl:text-[16px] lg:text-[14px] text-[13px] text-[#5B792E] px-[24px] lg:px-[30px] py-[10px] lg:py-[13px] font-bold"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(RouterPaths.UtilityVehicles);
              }}
            >
              EXPLORE TUATARA
            </button> */}
          </div>
        </div>

        {/* Right — text content */}
        <div className="flex items-center bg-white px-[24px] sm:px-[40px] lg:px-[60px] xl:px-[80px] py-[50px] lg:py-[70px] xl:py-[90px]">
          <div className="w-full">
            <h2 className="font-[Rockwell] 2xl:text-[36px] xl:text-[28px] lg:text-[22px] md:text-[24px] text-[20px] font-extrabold text-left mb-[16px] lg:mb-[20px]">
              ADVANCED TECHNOLOGY. SMARTER PERFORMANCE
            </h2>
            <p className="font-[Roboto] 2xl:text-[18px] xl:text-[16px] lg:text-[14px] text-[14px] font-normal text-left mb-[12px] lg:mb-[16px] text-[#292929] leading-relaxed">
              Tuatara UTVs are built with modern technology to help you get more
              out of every job. From improved efficiency to smarter vehicle
              management, our models are designed to deliver reliable
              performance across worksites, farms, and demanding environments.
            </p>
            <p className="font-[Roboto] 2xl:text-[18px] xl:text-[16px] lg:text-[14px] text-[14px] font-normal text-left mb-[24px] lg:mb-[30px] text-[#292929] leading-relaxed">
              For businesses and fleet operators, advanced telematics
              capabilities provide added control and visibility. Whether you
              manage a single vehicle or an entire fleet, Tuatara gives you the
              tools to work smarter, not harder.
            </p>
            <h3 className="font-[Roboto] 2xl:text-[20px] xl:text-[18px] lg:text-[15px] text-[15px] font-extrabold text-left mb-[12px] lg:mb-[16px]">
              CHECK BATTERY HEALTH ON FLEET VEHICLES REMOTELY
            </h3>
            <p className="font-[Roboto] 2xl:text-[18px] xl:text-[16px] lg:text-[14px] text-[14px] font-normal text-left mb-[30px] lg:mb-[40px] text-[#292929] leading-relaxed">
              The Tuatara's advanced telematics system provides real-time
              monitoring and management capabilities for your vehicle or fleet.
              This sophisticated system allows you to remotely check the battery
              health, ensuring optimal performance and longevity. With detailed
              insights into battery status, charge levels, and usage patterns,
              fleet managers can make informed decisions about maintenance and
              operational efficiency.
            </p>
            <div className="text-left">
              <button
                className="bg-[#F2F2F2] border-[#5B792E] border-[4px] rounded font-[Roboto] 2xl:text-[25px] xl:text-[23px] lg:text-[20px] md:text-[18px] sm:text-[15px] text-[15px] text-[#5B792E] 2xl:px-[150px] md:px-[48px] sm:px-[30px] px-[20px] 2xl:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold my-[10px]"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                EXPLORE TUATARA MODELS
              </button>
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildFleet;
